document.addEventListener('DOMContentLoaded', () => {
  const stickyCart = document.querySelector('sticky-add-to-cart');
  const stickyBar = stickyCart?.querySelector('.sticky-add-to-cart__bar');

  // Find the normal Add to Cart button/block on the product page
  const addToCartBlock = document.querySelector('.buy-buttons-block');

  if (!stickyCart || !stickyBar || !addToCartBlock) {
    console.log('Custom sticky cart: required elements not found');
    return;
  }

  console.log('🔥 CUSTOM STICKY CART JS RUNNING');

  const updateStickyCart = () => {
    const rect = addToCartBlock.getBoundingClientRect();

    // Normal Add to Cart block is above the viewport
    const isOffScreen = rect.bottom <= 0;

    if (isOffScreen) {
      stickyBar.dataset.stuck = 'true';
    } else {
      stickyBar.dataset.stuck = 'false';
    }
  };

  window.addEventListener('scroll', updateStickyCart, { passive: true });
  window.addEventListener('resize', updateStickyCart);

  // Run once immediately
  updateStickyCart();
});